import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo-white.svg';
import { userResetPassword, verifyUserOtp } from '../../api/loginApi';
import { toast } from 'sonner';
const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { email } = location.state || {};

  useEffect(() => {
    if (!email) {
      navigate('/forgotPassword');
    }
  }, [email]);
  const otpRefs = useRef([]);

  const [otp1, setOtp1] = useState('');
  const [otp2, setOtp2] = useState('');
  const [otp3, setOtp3] = useState('');
  const [otp4, setOtp4] = useState('');
  const [otp5, setOtp5] = useState('');
  const [otp6, setOtp6] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [error, setError] = useState('');

  const handleOtpChange = (e, otpNum) => {
    const { value } = e.target;
    if (isNaN(value)) return;
    switch (otpNum) {
      case 1:
        setOtp1(value);
        if (value && otpRefs.current[1]) otpRefs.current[1].focus();
        break;
      case 2:
        setOtp2(value);
        if (value && otpRefs.current[2]) otpRefs.current[2].focus();
        break;
      case 3:
        setOtp3(value);
        if (value && otpRefs.current[3]) otpRefs.current[3].focus();
        break;
      case 4:
        setOtp4(value);
        if (value && otpRefs.current[4]) otpRefs.current[4].focus();
        break;
      case 5:
        setOtp5(value);
        if (value && otpRefs.current[5]) otpRefs.current[5].focus();
        break;
      case 6:
        setOtp6(value);
        break;
      default:
        break;
    }
  };
  const handleKeyDown = (e, otpNum) => {
    if (e.key === 'Backspace' && !e.target.value && otpNum > 1) {
      otpRefs.current[otpNum - 2].focus();
    }
  };
  const handleSetPassword = async () => {
    const otp = `${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`;
    if (!password && !confirmPassword && isOtpValid) {
      setError('Password is required');
      return 'Password is required';
    } else if (password.length < 6 && isOtpValid) {
      setError('Password must be atleast 6 characters');
      return 'Password must be atleast 6 characters';
    }
    if (!otp || otp.length !== 6) {
      setError('Invalid OTP');
      setIsOtpValid(false);
      return 'Invalid OTP';
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return 'Passwords do not match';
    }

    if (isOtpValid) {
      toast.promise(userResetPassword(email, otp, password), {
        loading: 'Resetting password in...',
        success: (data) => {
          navigate('/login');
        },
        error: (err) => {
          setError('Invalid otp');
          console.log(err);
          return 'Invalid otp';
        },
        duration: 800,
      });
    } else {
      toast.promise(verifyUserOtp(email, otp), {
        loading: 'Verifying otp in...',
        success: (data) => {
          setIsOtpValid(true);
        },
        error: (err) => {
          setError('Invalid otp');
          console.log(err);
          setIsOtpValid(false);
          return 'Invalid otp';
        },
        duration: 800,
      });
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  return (
    <div className="theme-cyan">
      <div>
        <div className="vertical-align-wrap">
          <div className="vertical-align-middle auth-main">
            <div className="auth-box">
              <div className="top">
                <img
                  src={Logo}
                  alt="Lucid"
                  style={{ height: '40px', margin: '10px' }}
                />
              </div>
              <div className="card">
                <div className="header">
                  <p className="lead">Reset Password</p>
                </div>
                <div className="body">
                  {!isOtpValid ? (
                    <p>
                      Please enter the 6 digit otp you received on your email
                      address {email}
                    </p>
                  ) : (
                    <p>Please enter your new password</p>
                  )}
                  <div className="form-auth-small ng-untouched ng-pristine ng-valid">
                    {!isOtpValid && (
                      <div
                        className="form-group"
                        style={{ display: 'flex', gap: '2%' }}
                      >
                        {[1, 2, 3, 4, 5, 6].map((num) => (
                          <input
                            key={num}
                            className="form-control"
                            type="text"
                            value={eval(`otp${num}`)}
                            onChange={(e) => handleOtpChange(e, num)}
                            onKeyDown={(e) => handleKeyDown(e, num)}
                            maxLength={1} // Restrict to one character
                            ref={(el) => (otpRefs.current[num - 1] = el)} // Set ref for each input
                          />
                        ))}
                      </div>
                    )}

                    {isOtpValid && (
                      <div>
                        <div className="form-group">
                          <label className="control-label sr-only">
                            Password
                          </label>
                          <input
                            className="form-control"
                            id="signin-password"
                            placeholder="Password"
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                          />
                        </div>
                        <div className="form-group">
                          <label className="control-label sr-only">
                            Confirm Password
                          </label>
                          <input
                            className="form-control"
                            id="signin-password"
                            placeholder="Confirm Password"
                            type="password"
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                          />
                        </div>
                      </div>
                    )}
                    {error && (
                      <div className="error-message" style={{ color: 'red' }}>
                        {error}
                      </div>
                    )}
                    <button
                      className="btn btn-primary btn-lg btn-block"
                      type="submit"
                      onClick={handleSetPassword}
                    >
                      {isOtpValid ? 'RESET PASSWORD' : 'VERIFY OTP'}
                    </button>
                    <div className="bottom">
                      <span className="helper-text">
                        Know your password? <a href="login">Login</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ResetPassword.propTypes = {};

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(ResetPassword);
